const missionVision = [
  {
    title: "Our mission",
    copy: "Give training teams a clear, shared view of learner growth so every trainee is placement-ready on time.",
  },
  {
    title: "Our vision",
    copy: "A world where every cohort - regardless of location - has transparent goals, responsive mentors, and confident hiring outcomes.",
  },
];

const valueProps = [
  {
    title: "Outcome-first design",
    copy: "We start with the roles your learners are targeting and build backwards from there.",
  },
  {
    title: "People-centered",
    copy: "Human-friendly dashboards and nudges that respect attention and keep momentum.",
  },
  {
    title: "Reliable operations",
    copy: "Attendance, tasks, and placements stay synchronized so nothing slips through.",
  },
];

const team = [
  { name: "Devika Menon", role: "Director - Learning Experience", focus: "Instructional design & feedback loops" },
  { name: "Rahul Sethi", role: "Lead Trainer", focus: "Fullstack & DevOps coaching" },
  { name: "Megha Iyer", role: "Placement Lead", focus: "Hiring partner success & candidate prep" },
  { name: "Kunal Verma", role: "Program Ops", focus: "Cohort scheduling & attendance quality" },
];

const counters = [
  { value: "1,500+", label: "Learners guided" },
  { value: "210", label: "Placement drives supported" },
  { value: "4.8/5", label: "Average trainer rating" },
  { value: "18", label: "Cities covered" },
];

const About = () => {
  return (
    <div className="about-page page-section">
      <section className="page-banner">
        <div>
          <p className="eyebrow">About us</p>
          <h1>We are a training partner obsessed with placement-ready talent.</h1>
          <p className="muted">
            Our platform blends transparent learning journeys, responsive mentoring, and placement coordination so
            every trainee moves with confidence.
          </p>
        </div>
        <div className="banner-card">
          <p className="small muted">What we care about</p>
          <ul>
            <li>Clear milestones that reduce anxiety for learners and trainers alike.</li>
            <li>Reliable attendance and task signals to act on early.</li>
            <li>Placement experiences that feel supportive, not chaotic.</li>
          </ul>
        </div>
      </section>

      <section className="info-grid">
        {missionVision.map((item) => (
          <article key={item.title} className="info-card">
            <h3>{item.title}</h3>
            <p>{item.copy}</p>
          </article>
        ))}
      </section>

      <section className="value-section">
        <div className="section-header">
          <p className="eyebrow">What we provide</p>
          <h2>Structures that keep your cohorts calm and accountable.</h2>
        </div>
        <div className="card-grid trio">
          {valueProps.map((item) => (
            <article key={item.title} className="pill-card">
              <h3>{item.title}</h3>
              <p>{item.copy}</p>
            </article>
          ))}
        </div>
      </section>

      <section className="team-section">
        <div className="section-header">
          <p className="eyebrow">Trainer leadership</p>
          <h2>A team that blends industry craft with teaching empathy.</h2>
        </div>
        <div className="card-grid team-grid">
          {team.map((member) => (
            <article key={member.name} className="team-card">
              <div className="avatar">{member.name.charAt(0)}</div>
              <div>
                <h3>{member.name}</h3>
                <p className="muted">{member.role}</p>
                <p className="small">{member.focus}</p>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="counter-grid">
        {counters.map((item) => (
          <div key={item.label} className="counter-card">
            <p className="stat-value">{item.value}</p>
            <p className="stat-label">{item.label}</p>
          </div>
        ))}
      </section>
    </div>
  );
};

export default About;
